import styled, { createGlobalStyle, css } from 'styled-components';
import spacing from '../../styles/spacing';
import { vars } from '../../theme';
import { INPUT_SIZE_PROPS } from '../HBTextField/variables';
import { TControlSize } from '../../tokens/types';
import { ArrowDown16 } from '@honeybook/icons';

export const StyledTriggerWrapper = styled.div<{
    $width?: string | number;
    $size: TControlSize;
    $disabled?: boolean;
}>`
    display: inline-flex;
    align-items: center;
    width: ${({ $width }) =>
        $width
            ? typeof $width === 'number'
                ? `${$width}px`
                : $width
            : 'auto'};
    height: ${({ $size }) =>
        INPUT_SIZE_PROPS.system[$size]?.height ??
        INPUT_SIZE_PROPS.system.sm.height};
    background: ${vars.colors.surface.itemInset};
    border-radius: ${vars.radius.xs};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

    &:hover,
    &:focus {
        background: ${({ $disabled }) =>
            $disabled
                ? vars.colors.surface.itemInset
                : vars.colors.surface.itemInsetHover};
    }

    ${({ $disabled }) =>
        !$disabled &&
        css`
            &:focus-visible {
                outline: 2px solid ${vars.colors.stroke.keyboardFocus};
                outline-offset: 1px;
                border-radius: ${vars.radius.xs};
            }
        `}
`;

export const StyledTriggerText = styled.span<{
    $size: TControlSize;
    $hasValue: boolean;
}>`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: ${({ $size }) =>
        INPUT_SIZE_PROPS.system[$size]?.paddingLeft ?? spacing[12]};
    font-size: ${({ $size }) =>
        INPUT_SIZE_PROPS.system[$size]?.fontSize ?? '14px'};
    color: ${({ $hasValue }) =>
        $hasValue ? vars.colors.text.primary : vars.colors.text.tertiary};
`;

export const StyledChevronEnd = styled.span`
    flex-shrink: 0;
    padding-right: ${spacing[12]};
    display: flex;
    align-items: center;
`;

export const StyledChevronIcon = styled(ArrowDown16)`
    height: 16px;
`;

export const StyledSearchWrapper = styled.div`
    padding: ${spacing[4]} ${spacing[12]};
`;

export const COMBOBOX_MENU_CLASS = 'hb-combobox-menu-content';

export const ComboboxMenuOverrides = createGlobalStyle`
    .${COMBOBOX_MENU_CLASS} {
        --hb-list-content-padding-block-start: 2px;
        --hb-list-content-padding-block-end: 2px;
        --hb-menu-content-padding: ${spacing[12]} 0;
    }
`;
